
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 -7 28 22","width":"28","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.684 22H1.316C.59 22 0 21.395 0 20.652V3.41c0-.744.59-1.349 1.316-1.349h6.9c.253 0 .664-.19.83-.385l.768-.899C10.194.335 10.914 0 11.49 0h4.95c.576 0 1.296.335 1.676.778l.767.899c.167.195.578.385.83.385h6.972c.725 0 1.316.605 1.316 1.349v17.24c0 .744-.59 1.349-1.316 1.349zM1.316 3.212a.199.199 0 00-.193.198v8.448H4.77c.31 0 .561.257.561.575a.568.568 0 01-.561.575H1.123v7.643c0 .108.088.199.193.199h25.368c.105 0 .193-.09.193-.199v-7.643h-3.395a.568.568 0 01-.561-.575c0-.318.251-.575.561-.575h3.395V3.411a.198.198 0 00-.193-.199h-6.972c-.575 0-1.295-.334-1.674-.778l-.768-.898c-.166-.195-.578-.386-.83-.386h-4.95c-.253 0-.664.191-.831.386l-.768.898c-.378.444-1.098.778-1.674.778h-6.9zM14 19c-3.308 0-6-2.916-6-6.5S10.692 6 14 6s6 2.916 6 6.5-2.692 6.5-6 6.5zm0-11.88c-2.739 0-4.967 2.413-4.967 5.38s2.228 5.38 4.967 5.38c2.739 0 4.967-2.413 4.967-5.38S16.739 7.12 14 7.12zM14 16c-2.205 0-4-1.57-4-3.5S11.795 9 14 9c2.206 0 4 1.57 4 3.5S16.205 16 14 16zm0-5.88c-1.5 0-2.72 1.068-2.72 2.38 0 1.312 1.22 2.38 2.72 2.38 1.5 0 2.72-1.068 2.72-2.38 0-1.312-1.22-2.38-2.72-2.38z","vector-effect":"non-scaling-stroke"}})])
          )
        }
      }
    